
import { mapActions, mapMutations, mapState } from 'vuex';
import FInputPlaceholder from '@/components/atoms/mortgage-calculator/input-placeholder';
import FCalculatorInput from '@/components/molecules/forms/calculator-input';
import {
  MAX_AGE_INPUT,
  MIN_AGE_INPUT,
  MAX_INCOME_INPUT,
  MIN_INCOME_INPUT,
} from '@/utils/pension-calculator-constants';

export default {
  name: 'RetirementCalculatorInput',

  components: {
    FInputPlaceholder,
    FCalculatorInput,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    inputMode: {
      type: String,
      default: undefined,
    },
    options: {
      type: Array,
      required: false,
      default: () => null,
    },
    property: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
  },

  computed: {
    ...mapState({
      state: (state) => state['pension-calculator'].inputs,
      areInitialValuesSet: (state) =>
        state['pension-calculator'].areInitialValuesSet,
    }),

    errors() {
      const errorGetter = `${this.property}Errors`;

      const key = this.$store.getters[`pension-calculator/${errorGetter}`];
      if (
        key === 'form.validation.minimum' ||
        key === 'form.validation.maximum'
      ) {
        // Handle age validation
        if (this.property === 'age') {
          const field = this.$t('age');
          return this.$t(key, {
            field,
            minimum: MIN_AGE_INPUT,
            maximum: MAX_AGE_INPUT,
          });
        }
        // Handle income validation
        if (this.property === 'annual_gross_income') {
          return this.$t(`form.validation.income.${key.split('.').pop()}`, {
            minimum: MIN_INCOME_INPUT,
            maximum: MAX_INCOME_INPUT,
          });
        }
      }

      return this.$t(key);
    },

    value: {
      get() {
        const value = this.state[this.property];
        // TODO: create InputTypes constant and use it here
        return this.type === 'percentage' ? this.toPercent(value) : value;
      },
      set(newValue) {
        let value =
          this.type === 'percentage' ? this.fromPercent(newValue) : newValue;

        if (this.property === 'age') {
          value = Number(value);
        }

        this.setProperty({ property: this.property, value });
      },
    },
  },

  methods: {
    ...mapActions({
      setFormFocus: 'pension-calculator/setFormFocus',
    }),
    ...mapMutations({
      setProperty: 'pension-calculator/setInputProperty',
    }),

    bubble(e) {
      if (this.type === 'button-options') {
        this.value = e;
      }

      this.$emit('change', e);
    },

    handleBlur(e) {
      this.setFormFocus({ focused: false });
      this.$emit('blur', e);
    },

    handleFocus(e) {
      this.setFormFocus({ focused: true });
      this.$emit('focus', e);
    },

    toPercent(number) {
      const formatted = new Intl.NumberFormat('en', {
        minimumFractionDigits: 0,
      }).format(number * 100);

      return isNaN(formatted) ? 0 : formatted;
    },

    fromPercent(number) {
      if (!number) return 0;
      return number / 100;
    },
  },
};
